import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: "",
  stagesList: [],
  errMsg: null,
};

export const getPeopleStages = createAsyncThunk(
  "leads/getPeopleStages",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/leads/stages`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      console.log(error);
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

const stagesList = createSlice({
  name: "stagesList",
  initialState,
  extraReducers: {
    [getPeopleStages.pending]: (state) => {
      state.loading = true;
    },
    [getPeopleStages.fulfilled]: (state, action) => {
      state.loading = false;
      state.stagesList = action.payload.stages;
    },
    [getPeopleStages.rejected]: (state, action) => {
      state.loading = false;
      state.errMsg = action.payload;
    },
  },
});

export default stagesList.reducer;
